import * as React from "react";
import { ResourceDWR } from "../dto/SuggestionResult";
import { Button, Skeleton, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useLanguage } from "./Language";
import { TLCEventManager } from "../events/EventManager";
import { RequestButton, ResourceWithAvailability } from "./RequestButton";

//detailsListAndRequestControls
export interface DetailButtonsProps {
  isVirtualShelfEnabled: boolean; // ApplicationData.locationConfiguration.isVirtualShelfEnabled()
  resource: ResourceDWR | ResourceWithAvailability;
  onClickAddToList: (event: React.MouseEvent) => void;
  onClickVirtualShelf: (event: React.MouseEvent) => void;
  onClickDownloadableLink?: (event: React.MouseEvent) => void;
  onClickCheckoutDownloadable: (event: React.MouseEvent) => void;
  onClickPlaceRequest: (event: React.MouseEvent) => void;
  onClickViewSite?: (event: React.MouseEvent) => void;
}

export const RESOURCE_AVAILABILITY_LOADED = "resourceAvailabilityLoaded";
export interface ResourceAvailabilityLoadedEvent {
  resource: ResourceWithAvailability;
}

export const DetailButtons: React.FC<DetailButtonsProps> = ({
  isVirtualShelfEnabled,
  resource,
  onClickAddToList,
  onClickVirtualShelf,
  onClickDownloadableLink,
  onClickCheckoutDownloadable,
  onClickPlaceRequest,
  onClickViewSite,
}) => {
  const theme = useTheme();
  const fullSize = useMediaQuery(theme.breakpoints.up("md"));
  const { translate } = useLanguage();
  const [availabilityLoaded, setAvailabilityLoaded] =
    React.useState<boolean>(false);
  const [resourceWithAvailability, setResourceWithAvailability] =
    React.useState<ResourceWithAvailability>(null);

  React.useEffect(() => {
    // if the resource has any of the properties of ResourceWithAvailability set, mark as loaded
    if(resource.hasOwnProperty("disableRequestButton") 
    || resource.hasOwnProperty("hasDownloadbleCheckouts")
    || resource.hasOwnProperty("eResourceService")
    || resource.hasOwnProperty("actionsEnabled")
    || resource.hasOwnProperty("canCheckout")
    || resource.hasOwnProperty("showRequestButton")
    || resource.hasOwnProperty("eResourceHasAvailability")
    || resource.hasOwnProperty("holdingForOnShelf")
    || resource.hasOwnProperty("availability")
    ){
      setResourceWithAvailability(resource as ResourceWithAvailability);
      setAvailabilityLoaded(true);
    }
    const guid = TLCEventManager.addListener(
      RESOURCE_AVAILABILITY_LOADED,
      (event: ResourceAvailabilityLoadedEvent) => {
        if (event.resource.id === resource.id) {
          setResourceWithAvailability(event.resource);
          setAvailabilityLoaded(true);
        }
      }
    );
    return () => {
      TLCEventManager.removeListener(RESOURCE_AVAILABILITY_LOADED, guid);
    };
  }, []);

  return (
    <Stack direction={fullSize ? "row":"column-reverse"} gap={1} paddingTop={2} paddingBottom={2}>
      {availabilityLoaded ? (
        <RequestButton
          resource={resourceWithAvailability}
          onClickDownloadableLink={onClickDownloadableLink}
          onClickCheckoutDownloadable={onClickCheckoutDownloadable}
          onClickPlaceRequest={onClickPlaceRequest}
          onClickViewSite={onClickViewSite}
        ></RequestButton>
      ) : (
        <Skeleton height="36px" width="104px" />
      )}
      <Button variant="outlined" onClick={onClickAddToList}>
        {translate("addToList")}
      </Button>
      {/* look for .virtualShelf event handler */}
      {isVirtualShelfEnabled && resource.rtype === 1 && (
        <Button onClick={onClickVirtualShelf} variant="outlined">
          {translate("virtualShelfButtonText")}
        </Button>
      )}
    </Stack>
  );
};
